export default __webpack_public_path__ + "static/media/collaborators.3bb0aa5d.svg";